import React, { useContext } from "react";
import { TeamsContext } from "./TeamsContext";

export default function ParticipantControls({ participantId, teamId }) {
    const teams = useContext(TeamsContext);

    return (
        <div className="user-options">
            <select
                className="form-select user-action"
                data-userid={participantId}
                data-missionid={missionId}
                style={{ width: 140 }}
            >
                <option value="">Options</option>
                <optgroup label="Switch teams to:">
                    {teams.map((team, i) => {
                        if (team.id === teamId || team.id === 0) {
                            return;
                        }
                        return (
                            <option key={i} value={team.id}>
                                {team.name}
                            </option>
                        );
                    })}
                    <option value="individual">Individuals</option>
                </optgroup>
                <optgroup label="Other actions">
                    <option value="disable_user">Send to pending</option>
                    <option value="delete_user">Permanently delete</option>
                </optgroup>
            </select>
        </div>
    );
}
